import ImageWithFallback from '@components/ImageWithFallback/ImageWithFallback';
import faviconPlaceholder from '@static/vectors/placeholders/favicon-placeholder.svg';
import imagePlaceholder from '@static/vectors/placeholders/image-placeholder.svg';
import { extractDomain, getFaviconUrl } from '@utils/urlUtils';
import { useMemo } from 'react';
import type { NewsArticle } from 'src/types/sentinel';
import './SourceCard.css';

interface Props {
	source: NewsArticle;
}

export default function SourceCard({ source }: Props) {
	const Wrapper = source.url ? 'a' : 'div';
	const domain = useMemo(() => source.site_name || extractDomain(source.url), [source.site_name, source.url]);
	const faviconUrl = useMemo(() => source.icon_url || getFaviconUrl(domain), [source.icon_url, domain]);

	return (
		<li className="source-card">
			<Wrapper
				className="source-card-link"
				{...(source.url && {
					href: source.url,
					target: '_blank',
					rel: 'noopener noreferrer'
				})}
			>
				<div className="source-content">
					<ImageWithFallback
						className="preview-image"
						alt={source.title || 'Article preview'}
						src={source.image_url}
						fallbackSrc={imagePlaceholder}
					/>

					<div className="source-text">
						<div title={domain} className="source-meta">
							<ImageWithFallback className="site-icon" alt={`${domain} icon`} src={faviconUrl} fallbackSrc={faviconPlaceholder} />
							<span>{domain || 'Unknown source'}</span>
						</div>

						{source.title && (
							<div title={source.title} className="source-title ellipsis">
								{source.title}
							</div>
						)}
					</div>
				</div>
			</Wrapper>
		</li>
	);
}
